var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m969.98 102.75c68.016 0 123.19 55.172 123.19 123.24v743.9c0 68.062-55.172 123.24-123.19 123.24h-743.95c-68.062 0-123.24-55.172-123.24-123.24v-743.9c0-68.062 55.172-123.24 123.24-123.24zm0 99h-743.95c-13.359 0-24.188 10.875-24.188 24.234v743.9c0 13.406 10.828 24.234 24.188 24.234h743.95c13.359 0 24.188-10.828 24.188-24.234v-743.9c0-13.359-10.828-24.234-24.188-24.234zm-706.18 125.29c0-27.328 22.219-49.5 49.547-49.5h564.98c0.70312 0 1.4531 0 2.1562 0.046875 0.70312-0.046875 1.4062-0.046875 2.1562-0.046875 27.328 0 49.5 22.172 49.5 49.5v68.531c0 27.328-22.172 49.547-49.5 49.547s-49.5-22.219-49.5-49.547v-19.031h-187.82v442.78h35.109c27.328 0 49.5 22.172 49.5 49.5 0 27.328-22.172 49.5-49.5 49.5h-169.22c-27.328 0-49.5-22.172-49.5-49.5 0-27.328 22.172-49.5 49.5-49.5h35.109v-442.78h-183.47v19.031c0 27.328-22.172 49.547-49.5 49.547s-49.547-22.219-49.547-49.547z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFle);
export default __webpack_public_path__ + "static/media/text-fle.14e74a5234d36913ffff35192d654998.svg";
export { ForwardRef as ReactComponent };